// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file psypen/v1/gate.proto (package psypen.v1, syntax proto3)
/* eslint-disable */

// The gate's click path as a Connect service: the twin of GET and POST
// /pending (server/internal/loop/pending.go).

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { PendingAction } from "./session_pb";
import { file_psypen_v1_session } from "./session_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file psypen/v1/gate.proto.
 */
export const file_psypen_v1_gate: GenFile = /*@__PURE__*/
  fileDesc("ChRwc3lwZW4vdjEvZ2F0ZS5wcm90bxIJcHN5cGVuLnYxIhMKEUdldFBlbmRpbmdSZXF1ZXN0Ij8KEkdldFBlbmRpbmdSZXNwb25zZRIpCgdwZW5kaW5nGAEgASgLMhgucHN5cGVuLnYxLlBlbmRpbmdBY3Rpb24icAoUQW5zd2VyUGVuZGluZ1JlcXVlc3QSCgoCaWQYASABKAkSKAoGYW5zd2VyGAIgASgOMhgucHN5cGVuLnYxLlBlbmRpbmdBbnN3ZXISIgoDdmlhGAMgASgOMhUucHN5cGVuLnYxLlBlbmRpbmdWaWEiTgoVQW5zd2VyUGVuZGluZ1Jlc3BvbnNlEg0KBXJlcGx5GAEgASgJEiYKBG5leHQYAiABKAsyGC5wc3lwZW4udjEuUGVuZGluZ0FjdGlvbipjCg1QZW5kaW5nQW5zd2VyEh4KGlBFTkRJTkdfQU5TV0VSX1VOU1BFQ0lGSUVEEAASFwoTUEVORElOR19BTlNXRVJfU0VORBABEhkKFVBFTkRJTkdfQU5TV0VSX0NBTkNFTBACKj4KClBlbmRpbmdWaWESGwoXUEVORElOR19WSUFfVU5TUEVDSUZJRUQQABITCg9QRU5ESU5HX1ZJQV9LRVkQATKsAQoLR2F0ZVNlcnZpY2USSQoKR2V0UGVuZGluZxIcLnBzeXBlbi52MS5HZXRQZW5kaW5nUmVxdWVzdBodLnBzeXBlbi52MS5HZXRQZW5kaW5nUmVzcG9uc2USUgoNQW5zd2VyUGVuZGluZxIfLnBzeXBlbi52MS5BbnN3ZXJQZW5kaW5nUmVxdWVzdBogLnBzeXBlbi52MS5BbnN3ZXJQZW5kaW5nUmVzcG9uc2VCP1o9Z2l0aHViLmNvbS9hbXZpbm5vdmF0aXZlL3BzeXBlbi9zZXJ2ZXIvZ2VuL3BzeXBlbi92MTtwc3lwZW52MWIGcHJvdG8z", [file_psypen_v1_session]);

/**
 * @generated from message psypen.v1.GetPendingRequest
 */
export type GetPendingRequest = Message<"psypen.v1.GetPendingRequest"> & {
};

/**
 * Describes the message psypen.v1.GetPendingRequest.
 * Use `create(GetPendingRequestSchema)` to create a new message.
 */
export const GetPendingRequestSchema: GenMessage<GetPendingRequest> = /*@__PURE__*/
  messageDesc(file_psypen_v1_gate, 0);

/**
 * @generated from message psypen.v1.GetPendingResponse
 */
export type GetPendingResponse = Message<"psypen.v1.GetPendingResponse"> & {
  /**
   * Pending is what waits; absent when nothing does.
   *
   * @generated from field: psypen.v1.PendingAction pending = 1;
   */
  pending?: PendingAction | undefined;
};

/**
 * Describes the message psypen.v1.GetPendingResponse.
 * Use `create(GetPendingResponseSchema)` to create a new message.
 */
export const GetPendingResponseSchema: GenMessage<GetPendingResponse> = /*@__PURE__*/
  messageDesc(file_psypen_v1_gate, 1);

/**
 * @generated from message psypen.v1.AnswerPendingRequest
 */
export type AnswerPendingRequest = Message<"psypen.v1.AnswerPendingRequest"> & {
  /**
   * Id is what the box showed: the answer applies only if that is what
   * waits now. Empty answers whatever waits.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: psypen.v1.PendingAnswer answer = 2;
   */
  answer: PendingAnswer;

  /**
   * @generated from field: psypen.v1.PendingVia via = 3;
   */
  via: PendingVia;
};

/**
 * Describes the message psypen.v1.AnswerPendingRequest.
 * Use `create(AnswerPendingRequestSchema)` to create a new message.
 */
export const AnswerPendingRequestSchema: GenMessage<AnswerPendingRequest> = /*@__PURE__*/
  messageDesc(file_psypen_v1_gate, 2);

/**
 * @generated from message psypen.v1.AnswerPendingResponse
 */
export type AnswerPendingResponse = Message<"psypen.v1.AnswerPendingResponse"> & {
  /**
   * @generated from field: string reply = 1;
   */
  reply: string;

  /**
   * Next is what waits after it; absent when nothing does.
   *
   * @generated from field: psypen.v1.PendingAction next = 2;
   */
  next?: PendingAction | undefined;
};

/**
 * Describes the message psypen.v1.AnswerPendingResponse.
 * Use `create(AnswerPendingResponseSchema)` to create a new message.
 */
export const AnswerPendingResponseSchema: GenMessage<AnswerPendingResponse> = /*@__PURE__*/
  messageDesc(file_psypen_v1_gate, 3);

/**
 * PendingAnswer is the user's answer at the gate. Nothing that waits is
 * rewritten by hand: to change it, the user says what to change.
 *
 * @generated from enum psypen.v1.PendingAnswer
 */
export enum PendingAnswer {
  /**
   * @generated from enum value: PENDING_ANSWER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PENDING_ANSWER_SEND = 1;
   */
  SEND = 1,

  /**
   * @generated from enum value: PENDING_ANSWER_CANCEL = 2;
   */
  CANCEL = 2,
}

/**
 * Describes the enum psypen.v1.PendingAnswer.
 */
export const PendingAnswerSchema: GenEnum<PendingAnswer> = /*@__PURE__*/
  enumDesc(file_psypen_v1_gate, 0);

/**
 * PendingVia is the path the answer came by; only the metric reads it.
 *
 * @generated from enum psypen.v1.PendingVia
 */
export enum PendingVia {
  /**
   * The box's buttons.
   *
   * @generated from enum value: PENDING_VIA_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The orb's keys.
   *
   * @generated from enum value: PENDING_VIA_KEY = 1;
   */
  KEY = 1,
}

/**
 * Describes the enum psypen.v1.PendingVia.
 */
export const PendingViaSchema: GenEnum<PendingVia> = /*@__PURE__*/
  enumDesc(file_psypen_v1_gate, 1);

/**
 * GateService is what waits at the gate for the user's answer, and the
 * answer.
 *
 * @generated from service psypen.v1.GateService
 */
export const GateService: GenService<{
  /**
   * GetPending is GET /pending.
   *
   * @generated from rpc psypen.v1.GateService.GetPending
   */
  getPending: {
    methodKind: "unary";
    input: typeof GetPendingRequestSchema;
    output: typeof GetPendingResponseSchema;
  },
  /**
   * AnswerPending is POST /pending. FailedPrecondition when nothing waits
   * any more (it was answered or it expired).
   *
   * @generated from rpc psypen.v1.GateService.AnswerPending
   */
  answerPending: {
    methodKind: "unary";
    input: typeof AnswerPendingRequestSchema;
    output: typeof AnswerPendingResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_psypen_v1_gate, 0);

